import React from "react";
import { Button, Drawer, Modal, Space } from "antd";
import { MyLoader } from "Components/MyLoader/MyLoader";
import { DeleteFilled, IssuesCloseOutlined } from "@ant-design/icons";

import "./index.css";
import MyBtnConfirm from "Components/MyBtnConfirm/MyBtnConfirm";
import { defaultSettings } from "css/defaultAntStyles";
export const DrawerWrapper = ({
  showEditBtn = false,
  showCreateBtn = false,
  showDeleteBtn = false,
  headerBtn = () => {},
  title = "",
  open = false,
  setOpen = () => {},
  children,
  form,
  placement = "left",
  width = 420,
  isLoading = false,
  padding = "",
  disabled = false,
  destroyOnHidden = false,
  push = "",
  handleConfirmDelete = () => {},
  // onConfirm = null,
  withoutConfirm = false,
}) => {
  const [modal, contextHolder] = Modal.useModal();

  const showConfirmClose = () => {
    modal.confirm({
      title: "Закрити бланк без збереження?",
      content: "",

      okText: "Так",
      cancelText: "Скасувати",

      onOk: async () => {
        // if (onConfirm) {
        //   await onConfirm();
        // }
        setOpen();
        form?.resetFields();
      },
      maskClosable: true,
      icon: (
        <IssuesCloseOutlined style={{ color: defaultSettings.colorPrimary }} />
      ),
    });
  };
  const showConfirmCreate = () => {
    modal.confirm({
      title: "Створити бланк?",
      content: "",

      okText: "Так",
      cancelText: "Скасувати",

      onOk: () => {
        if (showCreateBtn) {
          form.submit();
        }
      },
      maskClosable: true,
      icon: (
        <IssuesCloseOutlined style={{ color: defaultSettings.colorPrimary }} />
      ),
    });
  };

  return (
    <>
      {contextHolder}
      <Drawer
        className="my-drawer-wrapper-scroll-custom"
        title={title}
        placement={placement}
        width={width}
        open={open}
        onClose={() => {
          if (withoutConfirm || disabled) {
            setOpen();
            form?.resetFields();
          } else {
            showConfirmClose();
          }
          // if (onConfirm) {
          // } else {
          // setOpen();
          // form?.resetFields();
          // }
        }}
        destroyOnHidden={destroyOnHidden}
        styles={{
          body: {
            padding: padding,
            overflowY: "none",
          },
        }}
        push={push}
        extra={
          <Space>
            {headerBtn?.()}

            {showCreateBtn && (
              <Button
                disabled={disabled}
                loading={isLoading}
                type="primary"
                onClick={showConfirmCreate}
              >
                Створити
              </Button>
            )}
            {showEditBtn && !disabled && (
              <Button
                disabled={disabled}
                loading={isLoading}
                type="primary"
                onClick={() => form.submit()}
              >
                Редагувати
              </Button>
            )}
            {showDeleteBtn && !disabled && (
              <MyBtnConfirm
                mainTitle={"Ви дійсно хочете видалити бланк?"}
                disabled={disabled}
                isLoading={isLoading}
                type="default"
                icon={
                  <DeleteFilled
                    style={{ color: defaultSettings.colorPrimary }}
                  />
                }
                btnIcon={
                  <DeleteFilled
                    style={{ color: defaultSettings.colorPrimary }}
                  />
                }
                onConfirm={handleConfirmDelete}
              />
            )}
          </Space>
        }
      >
        {isLoading ? <MyLoader centered={true} /> : children}
      </Drawer>
    </>
  );
};
